import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { PatientNotes } from '@stockcare-models/IPatientNotes';

@Component({
  standalone: false,
  selector: 'app-note-card-item',
  templateUrl: './note-card-item.component.html',
  styleUrls: ['./note-card-item.component.scss']
})
export class NoteCardItemComponent implements OnInit, OnDestroy {
  @Input() patientNote: PatientNotes;

  constructor() {}

  ngOnInit() {}

  ngOnDestroy(): void {
  }
}
